module.exports = __webpack_public_path__ + "img/lock.3ea04442.svg";